import { RelaySDK } from '@fiverr-private/relay-sdk/dist/legacy'; // Transpiled to ES5 syntax. Monicore does not support ES6.
import { globalEventBus } from '@fiverr-private/futile';
import getMetaTagContent from '../../../helpers/getMetaTagContent';
import { BUS_EVENT_NAME } from '../../constants';
import { CTX_ID } from '../../../helpers/metaTagIdentifiers';

/**
 *
 * @param {string} host the API base is taken from a new meta tag browser_relay_service_api
 * @param {string} mode The environment mode (development or production)
 * @returns {{ setEnricher: (enricher: () => import('@fiverr-private/relay-sdk').Context) => void }}
 */
export function monicoreListener({ host, mode }) {
    if (globalEventBus.has(BUS_EVENT_NAME)) { return; } // Prevent multiple listeners
    if (!host) { return; }

    /**
     * Backward compatibility with older OBS version for "host" and "context" arguments: Old URL and no context data
     * TODO: Remove this in the next major version (2.0.0)
     */
    host = /\/v\d\//.test(host) ? new URL(host).origin : host;
    const relaySDK = new RelaySDK({
        id: getMetaTagContent(CTX_ID) || undefined,
        endpoint: `${host}/v3/relay`,
        mode
    });

    globalEventBus.on(BUS_EVENT_NAME, ({ events }) => {
        relaySDK.monicore(
            ...events.map(

                // Strip the context fields from events.
                // Parameters<RelaySDK['monicore']>[0] (MonicoreEntry)
                ({ type, name, duration, value }) => ({
                    type,
                    name,
                    duration,
                    value
                })
            )
        );
    });
    const listener = {

        /**
         * @param {() => import('@fiverr-private/relay-sdk').Context} enricher
         * @returns {listener}
         */
        setEnricher: (enricher) => {
            relaySDK.registerContext('monicore', enricher());
            return listener;
        }
    };
    return listener;
}
